export default __webpack_public_path__ + "static/media/sonyyay.05275ec5.png";